export default __webpack_public_path__ + "static/media/learn-chinese.ac533886.png";